import React from 'react';
import { Container } from 'reactstrap';
import IconAppleStore from '../../assets/images/icon-app-store.png';
import IconGooglePlay from '../../assets/images/icon-google-play.png';
import { siteParams } from '../../config/site';
import { Link, LinkExternal } from '../../assets/styles/components';

const Footer = () => (
  <div className="footer-main  mt-5">
    <Container>
      <h2 className="text-center">Baixe o nosso app</h2>
      <div className="text-center">
        <LinkExternal href={siteParams.download.ios.store} className="mr-2">
          <img alt="" src={IconAppleStore} height="50" />
        </LinkExternal>
        <LinkExternal href={siteParams.download.android.store}>
          <img alt="" src={IconGooglePlay} height="50" />
        </LinkExternal>
      </div>

      <div className="row mt-3">
        <div className="col-md-6 col-sm-12 float-md-left footer-left">
          2018 - Todos os direitos reservados
        </div>
        <div className="col-md-6 col-sm-12 float-md-right footer-right">
          <LinkExternal href={siteParams.links.duvidas} className="mr-3">
            Dúvidas
          </LinkExternal>
          <LinkExternal href={siteParams.links.politicaDePrivacidade} className="mr-3">
            Política de Privacidade
          </LinkExternal>
          <LinkExternal href={siteParams.links.termosDeUso} className="mr-3">
            Termos de Uso
          </LinkExternal>
          <LinkExternal href={`mailto:${siteParams.contactEmail}`}>Fale Conosco</LinkExternal>
        </div>
      </div>
    </Container>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js